module.exports = __webpack_public_path__ + "static/media/p3.f4f45d8b.svg";